import { IAdHocSendEvent } from '../../../lib/types/communication.types';
import { StatusTone } from '../../_core/_ui/status-chip.types';

export const statusTone = (status: string | undefined): StatusTone => {
  switch (status) {
    case 'Success': return 'success';
    case 'Queued': return 'info';
    case 'Pending': return 'pending';
    case 'Failed':
    case 'Failed - Timed Out':
    case 'Error': return 'danger';
    default: return 'neutral';
  }
};

// Just the five row-status counts a send event aggregates — the inputs to its
// settle state and delivery progress.
type SendEventCounts = Pick<
  IAdHocSendEvent,
  'sentCount' | 'failedCount' | 'skippedCount' | 'queuedCount' | 'pendingCount'
>;

// A send event is unsettled while any row still awaits pickup (Queued) or is
// mid-delivery (Pending); its final tally is withheld until this reaches zero.
export const isSendEventUnsettled = (event: SendEventCounts): boolean =>
  event.queuedCount + event.pendingCount > 0;

export interface ISendEventProgress {
  // Every message in the group (all five counts summed).
  total: number;
  // Successfully-delivered rows so far — the numerator of the in-progress line.
  delivered: number;
  // Rows still queued or pending.
  unsettled: number;
  settled: boolean;
}

// Delivery progress for the in-progress summary, derived from the five counts.
export const sendEventProgress = (event: SendEventCounts): ISendEventProgress => {
  const unsettled = event.queuedCount + event.pendingCount;
  const total = event.sentCount + event.failedCount + event.skippedCount + unsettled;
  return { total, delivered: event.sentCount, unsettled, settled: !isSendEventUnsettled(event) };
};
